<hx-form-group [error]="_hasError()">
  @if (label() || subtitle()) {
    <hx-label
      [description]="label()"
      [subtitle]="subtitle()"
      [required]="required()"
      [fontWeight]="labelFontWeight()"
      [fontSize]="labelFontSize()"
      [subtitleFontWeight]="subtitleFontWeight()"
      [subtitleFontSize]="subtitleFontSize()"
      [color]="labelColor()"
      [subtitleColor]="subtitleColor()"
      [tooltip]="tooltip()"
      [tooltipPosition]="tooltipPosition()"
      [tooltipColor]="tooltipColor()"></hx-label>
  }
  <hx-dropdown
    [options]="_optionsWithOther()"
    [placeholder]="placeholder()"
    [panelClass]="panelClass()"
    [size]="size()"
    [searchable]="searchable()"
    [allowFreeText]="allowFreeText()"
    [multiple]="_isMultipleMode()"
    [showSelectAll]="showSelectAll()"
    [virtualScroll]="virtualScroll()"
    [itemSize]="itemSize()"
    [error]="_hasError()"
    [readonly]="!!readonly()"
    [disabled]="!!disabled()"
    [showTriggerTooltip]="showTriggerTooltip()"
    [formControl]="_internalControl"
    (valueChange)="_onValueChange($event)"
    (opened)="_onOpenChange(true)"
    (closed)="_onOpenChange(false)"></hx-dropdown>

  @if (_isOtherSelected()) {
    <div class="hx-dropdown-with-label__other-input">
      <hx-form-group [error]="_otherFieldHasError()">
        @if (otherInputControl(); as oc) {
          <hx-input
            type="text"
            [label]="otherLabel()"
            [placeholder]="otherPlaceholder()"
            [formControl]="oc"
            [size]="size()"
            [required]="true"
            [error]="_otherFieldHasError()"
            [requiredErrorMessage]="_otherErrorMessage()"
            (blur)="_handleOtherBlur()"></hx-input>
        } @else {
          <hx-input
            type="text"
            [label]="otherLabel()"
            [placeholder]="otherPlaceholder()"
            [formControl]="_otherInputControl"
            [size]="size()"
            [required]="true"
            [error]="_otherFieldHasError()"
            [requiredErrorMessage]="_otherErrorMessage()"
            (blur)="_handleOtherBlur()"></hx-input>
        }
      </hx-form-group>
    </div>
  }
  @if (showTags() && _isMultipleMode() && _selectedTags().length > 0) {
    @if (tagsLabel()) {
      <div class="tags-label">
        <hx-label [description]="tagsLabel()!"></hx-label>
      </div>
    }
    <div class="tags-container">
      @for (tag of _selectedTags(); track tag.value) {
        <hx-tag
          [label]="tag.label"
          [removable]="!disabled()"
          [maxWidth]="undefined"
          [size]="_tagSize()"
          [variant]="tagVariant()"
          (removed)="_onTagRemove(tag.value)"></hx-tag>
      }
    </div>
  }

  @if (hint()) {
    <div hx-hint>{{ hint() }}</div>
  }
  @if (_activeErrorMessage()) {
    <span hx-error>{{ _activeErrorMessage() }}</span>
  }
</hx-form-group>
